import axios from 'axios'
import lib from '@/lib'
import jslib from '@mexipassit/jslib'
import creditCardType from 'credit-card-type'

export default {

  env: function() {
    let url = window.location.hostname
    if ( url.toLowerCase().includes('localhost') ) {
      return 'dev'
    } else if ( url.toLowerCase().includes('staging.') ) {
      return 'test'
    } else {
      return 'prod'
    }
  },

  isDev: function() {
    return this.env() == 'dev'
  },

  isTest: function() {
    return this.env() == 'test'
  },

  isProd: function() {
    return this.env() == 'prod'
  },

  toDate(s) {
    s = (s || '').replace(/[^ -~]/g,'')
    let d = new Date(s)
    if ( isNaN(d.getTime()) ) {
      d = new Date(s.replace(/-/g, '/'))
    }
    return d
  },

  birthDateFilledButIsGarbage(d) {
    let bits = d.split(new RegExp(['\\.', '\\-', '\\/'].join('|'), 'g'))

    if ( bits[0] != undefined && bits[0] != '' && (+bits[0] < 1 || +bits[0] > 12) ) {
      return true
    }

    if ( bits[1] != undefined && bits[1] != '' && (+bits[1] < 1 || +bits[1] > 31) ) {
      return true
    }

    if ( bits[2] != undefined &&  bits[2].length == 4 && (+bits[2] < ((new Date()).getFullYear() -120) || +bits[2] > (new Date()).getFullYear()) ) {
      return true
    }

    return false
  },

  birthDateSomewhatAlright(d) {
    let bits = d.split(new RegExp(['\\.', '\\-', '\\/'].join('|'), 'g'))

    if ( bits[0] === undefined || bits[0].trim() == '' || +bits[0] < 1 || +bits[0] > 12 ) {
      return false
    }

    if ( bits[1] === undefined || bits[1].trim() == '' || +bits[1] < 1 || +bits[1] > 31 ) {
      return false
    }

    if ( bits[2] === undefined || bits[2].trim() == '' || (+bits[2] < ((new Date()).getFullYear() -120)) || (+bits[2] > ((new Date()).getFullYear())) ) {
      return false
    }

    return true
  },

  googleAddressComponents(place) {
    return place?.addressComponents || place?.address_components || []
  },

  googleLongText(component) {
    return component?.longText || component?.long_name || ''
  },

  googleShortText(component) {
    return component?.shortText || component?.short_name || ''
  },

  googleToAddress(place) {
    let ret = ''

    if (place && (place.formattedAddress || place.formatted_address)) {
      ret = place.formattedAddress || place.formatted_address

      if (ret.includes(', EE. UU.')) {
        ret = ret.replace(', EE. UU.', ', USA')
      }
    }

    return ret
  },

  googleToStreetNumber(place) {
    let ret = ''
    let components = this.googleAddressComponents(place)

    if (components.length > 0) {
      let comp = components.find(c => c.types && c.types.includes('street_number'))
      ret = comp ? this.googleLongText(comp) : ''
    }

    return ret
  },

  googleToStreet(place) {
    let ret = ''
    let components = this.googleAddressComponents(place)

    if (components.length > 0) {
      let comp = components.find(c => c.types && c.types.includes('route'))
      ret = comp ? this.googleLongText(comp) : ''
    }

    return ret
  },

  googleToCity(place) {
    let ret = ''
    let components = this.googleAddressComponents(place)

    if (components.length > 0) {
      // Prefer true city-level fields before any neighborhood-like fallback.
      const cityTypePriority = [
        'locality',
        'postal_town',
        'administrative_area_level_3',
      ]

      let comp = null

      for (const cityType of cityTypePriority) {
        comp = components.find(c => c.types && c.types.includes(cityType))
        if (comp) {
          break
        }
      }

      ret = comp ? this.googleLongText(comp) : ''
    }

    return ret
  },

  googleToState(place, long = false) {
    let ret = ''
    let components = this.googleAddressComponents(place)

    if (components.length > 0) {
      let comp = components.find(c => c.types && c.types.includes('administrative_area_level_1'))
      ret = comp ? (long ? this.googleLongText(comp) : this.googleShortText(comp)) : ''
    }

    return ret
  },

  googleToZip(place) {
    let ret = ''
    let components = this.googleAddressComponents(place)

    if (components.length > 0) {
      let component = components.find(item => item.types && item.types.includes('postal_code'))
      ret = component ? this.googleLongText(component) : ''
    }

    return ret
  },

  googleToCountry(place) {
    let ret = ''
    let components = this.googleAddressComponents(place)

    if (components.length > 0) {
      let component = components.find(item => item.types && item.types.includes('country'))

      if (!component)
        return ''

      let isoCode = this.googleShortText(component).toUpperCase()

      if (isoCode === 'US') {
        return 'USA'
      } else if (isoCode === 'CA') {
        return 'Canada'
      } else if (isoCode === 'MX') {
        return 'Mexico'
      } else {
        let longName = this.googleLongText(component).toUpperCase()
        if (longName.includes('UNITED STATES')) return 'USA'
        if (longName.includes('CANADA')) return 'Canada'
        if (longName.includes('MEXICO')) return 'Mexico'
        
        return ''
      }
    }

    return ret
  },

  googleFormatStreet(place) {
    return (this.googleToStreetNumber(place) + ' ' + this.googleToStreet(place)).trim()
  },

  normalizefromMDYtoYYYYMMDD(d) {
    let bits = d.split(new RegExp(['\\.', '\\-', '\\/'].join('|'), 'g'))

    return (+bits[2]).toString().padStart(4, '0') + '-' + (+bits[0]).toString().padStart(2, '0') + '-' + (+bits[1]).toString().padStart(2, '0')
  },

  paymentCreditCardCode(str) {
    let ccType = creditCardType(str)
    ccType = ccType.length == 1 ? ccType[0].type : ''
    ccType = ccType == 'visa' ? 'VI' : ccType == 'mastercard' ? 'MC' : ccType == 'discover' ? 'DI' : ccType == 'american-express' ? 'AE' : ''

    return ccType
  },

  async getTextFile(url) {
    return await axios({
      method: 'get',
      responseType: 'text',
      url
    })
  },

  async submitPayment(args, totalTime) {

    let endpoint = jslib.config.endpoints.buyPayment[this.env()]

    let thisRoundStart = new Date().getTime()
    totalTime = isNaN(totalTime) ? 0 : totalTime

    let payload = {
      appid: jslib.detectUrlMexiPolicyProId(),
      program: args.Program,
      liability_limit: args.SelectedLiabilityLimit,
      producer_code: args.ProducerCode,
      effective_date: this.normalizefromMDYtoYYYYMMDD( args.CoverageAndPaymentStartDate.replace(/[^ -~]/g,'') ), // Edge/IE fix, they add invisible bom characters which fail new Date() to parse
      app_record_id: args.RaterApplicationId.toString(),
      veh_record_id: args.RaterVehicleId.toString(),
      days_trip: args.SelectedDaysOfCoverage,
      vehicle_primarily_in_mexico: args.VehiclePrimarilyInMexico,
      applicant: {
        first_name: args.ApplicantFirstName,
        last_name: args.ApplicantLastName,
        birth_month: (+args.ApplicantDateOfBirth.split('-')[0]).toString().padStart(2, '0'),
        birth_day: (+args.ApplicantDateOfBirth.split('-')[1]).toString().padStart(2, '0'),
        birth_year: (+args.ApplicantDateOfBirth.split('-')[2]).toString().padStart(4, '0'),
        country: this.googleToCountry(args.ApplicantAddressGoogle) || 'USA', // temp hack, remove 'usa' as default once the sporadic country issue is fixed
        street_address: this.googleFormatStreet(args.ApplicantAddressGoogle),
        street_address_unit: args.ApplicantUnit,
        city: this.googleToCity(args.ApplicantAddressGoogle),
        state: this.googleToState(args.ApplicantAddressGoogle, true),
        postal_code: this.googleToZip(args.ApplicantAddressGoogle),
        phone1: args.ApplicantPhone.replace(/\D/g, '').substr(0, 3),
        phone2: args.ApplicantPhone.replace(/\D/g, '').substr(3, 3),
        phone3: args.ApplicantPhone.replace(/\D/g, '').substr(6, 4),
        email: args.ApplicantEmail,
        googleCountryMatch: this.googleToCountry(args.ApplicantAddressGoogle),
        googleAddress: args.ApplicantAddressGoogle,
      },
      payment: {
        card_type: this.paymentCreditCardCode(args.PaymentCreditCard),
        card_name: args.PaymentFirstAndLastName,
        card_number: args.PaymentCreditCard,
        cvv: args.PaymentCVC,
        expiration_date: args.PaymentMM + args.PaymentYY,
        postal_code: args.PaymentZip,
      },
      vehicle: {
        year: args.VehicleYear,
        make: args.VehicleMake,
        model: args.VehicleModel,
        vin: args.VehicleVin,
        licenseplate: args.LicensePlate,
        statelicensed: args.SelectedVehicleState,
        countrylicensed: args.SelectedVehicleCountry,
        type: args.VehicleType,
        value: args.SelectedVehicleValue,
      },
      driver: {
        first_name: args.DriverInfoFirstName,
        last_name: args.DriverInfoLastName,
        license_number: args.DriversLicense,
        license_state: args.SelectedDriverInfoState,
        license_country: args.SelectedDriverInfoCountry,
        birth_month: (+args.DriverInfoDateOfBirth.split('-')[0]).toString().padStart(2, '0'),
        birth_day: (+args.DriverInfoDateOfBirth.split('-')[1]).toString().padStart(2, '0'),
        birth_year: (+args.DriverInfoDateOfBirth.split('-')[2]).toString().padStart(4, '0'),
      },
    }

    if ( args.LienholderSelection === true ) {
      payload.lienholder = {
        name: args.LienholderName,
        country: args.LienholderCountry,
        street_address_1: args.LienholderAddress1,
        street_address_2: args.LienholderAddress2,
        city: args.LienholderCity,
        state: args.LienholderState,
        postal_code: args.LienholderPostalCode
      }
    }

    payload.monitorOnly = totalTime > 0

    try {
      // 120s timeout is more than the aws gateway allows, since it only goes up to 29s, just for safety of individual calls
      return await axios({
        url: endpoint.url,
        method: 'POST',
        timeout: 60 * 60 * 1000,
        headers: { 'Content-Type': 'application/json', 'x-api-key': endpoint.key },
        data: payload
      })
    } catch (ex) {
      let elapsedTime = (new Date().getTime() - thisRoundStart)
      // if the current error is due to a long call, at least 25s, then it may be a aws gateway timeout, which maxes at 29s
      // while the actual aws lambda is set up to retry up to 10 minutes, so here I will retry around that time max
      if ( elapsedTime > 25000 && totalTime < 660000 ) {
        // eslint-disable-next-line
        console.log('retrying due to timeout')
        return await this.submitPayment(args, totalTime + elapsedTime)
      } else {
        onerror && onerror(ex)
      }
    }
  },

  async vinInformation(args) {

    let endpoint = jslib.config.endpoints.VinLookup[this.env()]

    let payload = {
      appid: jslib.detectUrlMexiPolicyProId(),
      vin: args.vin,
      rid: args.rid
    }

    let headers = { headers: { 'Content-Type': 'application/json', 'x-api-key': endpoint.key } }

    return axios.post(endpoint.url, payload, headers)
  },

  async getRates(args) {
    let endpoint = jslib.config.endpoints.buyRater[this.env()]

    // grab utms from session storage if present
    //let pendingUtms = sessionStorage.getItem('pending_utms')
    return await axios.post(endpoint.url, {
      appid: jslib.detectUrlMexiPolicyProId(),
      program: args.Program,
      producer_code: args.ProducerCode,
      days_trip: args.SelectedDaysOfCoverage,
      vehicle_value: args.SelectedVehicleValue,
      liability_limit: args.SelectedLiabilityLimit,
      app_record_id: args.RaterApplicationId,
      veh_record_id: args.RaterVehicleId,
      vehicle_primarily_in_mexico: args.VehiclePrimarilyInMexico,
      garaging_state: args.garagingState,
      garaging_municipality: args.garagingMunicipality,
      analyticsUrlParameters: window.location.search,
      //analyticsUrlParameters: pendingUtms ? `?${pendingUtms}` : '',
    }, { headers: { 'Content-Type': 'application/json', 'x-api-key': endpoint.key } })
  },

  async agencyInfo(producerCode) {
    let endpoint = jslib.config.endpoints.buyAgencyInfo[lib.env()]
    let payload = {
      appid: jslib.detectUrlMexiPolicyProId(),
      producer_code: producerCode,
      countries: true,
      states: true,
      municipalities: true,
    }

    let headers = { 'Content-Type': 'application/json', 'x-api-key': endpoint.key }

    let result = await axios.post(endpoint.url, payload, { headers })

    if ( result.data.success ) {
      return result.data
    } else {
      throw `bad result`
    }
  },

  async getContacted(args) {
    let endpoint = jslib.config.endpoints.contact[this.env()]

    return await axios.post(endpoint.url, {
      appid: jslib.detectUrlMexiPolicyProId(),
      template: 'Contact - buy - producer',
      producer_code: args.ProducerCode,
      variables: {
        producer_code: args.ProducerCode,
        contact_name: args.ContactName,
        contact_info: args.ContactEmailOrPhone
      }
    }, {
      headers: { 'Content-Type': 'application/json', 'x-api-key': endpoint.key }
    })
  },

  mapInsuranceCompany(s) {
    if ( s != undefined && s != null ) {
      if ( s.toUpperCase().trim() == 'AIG' ) {
        return 'aig'
      } else if ( ['ACE', 'CHUBB'].includes(s.toUpperCase().trim()) ) {
        return 'chubb'
      } else {
        return ''
      }
    } 
  },

  interpolate(s, o) {
    if ( s === undefined || s === null ) {
      return s
    }
    let matches
    while ( (matches = s.match(/{{([^}]+)}}/g)) != null && matches.length>0 ) {
      let key = matches[0].substring(2, matches[0].length-2)
      if ( key.substring(0, 1) == '$' ) {
        if ( o[key.substring(1)] != undefined ) {
          s = s.replace('{{' + key + '}}', '$' + o[key.substring(1)].toLocaleString())
        } else {
          break
        }
      } else {
        if ( o[key] != undefined ) {
          s = s.replace('{{' + key + '}}', o[key])
        } else {
          break
        }
      }
    }
    return s
  },

  getAge(dateString) {
    let today = new Date()
    let birthDate = this.toDate(dateString)
    let age = today.getFullYear() - birthDate.getFullYear()
    let m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m == 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  },

  dobTodayWithinYearRange(dob, notYoungerThanYears, notOlderThanYears) {
    let age = this.getAge(dob)
    return age >= notYoungerThanYears && age <= notOlderThanYears
  },

  formatPrice(v) {
    let parsed = parseFloat(v)
    if (isNaN(parsed)) return ''
    let c = '$' + parsed.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    return c == '$' ? '' : c
  },

  nextRoute($router, liabilityOnly, stamp) {
    for ( let i = 0; i < $router.options.routes.length-1; i++ ) {
      if ( $router.options.routes[i].name == $router.currentRoute.value.name ) {
        do {
          i++
        } while ( (liabilityOnly === true && $router.options.routes[i].onlyIfNotLiabilityOnly === true) || (stamp === true && $router.options.routes[i].notForStamp === true))
        $router.push({ name: $router.options.routes[i].name })
        break
      }
    }
  },

  previousRoute($router, liabilityOnly, stamp) {
    for ( let i = $router.options.routes.length-1; i > 0 ; i-- ) {
      if ( $router.options.routes[i].name == $router.currentRoute.value.name ) {
        do {
          i--
        } while ( (liabilityOnly === true && $router.options.routes[i].onlyIfNotLiabilityOnly === true) || (stamp === true && $router.options.routes[i].notForStamp === true))

        $router.push({ name: $router.options.routes[i].name })
        break
      }
    }
  },

  ga(o) {
    window.dataLayer = window.dataLayer || []

    let href = (window.location && window.location.href ? window.location.href : '').toLowerCase()
    if ( !href.includes('localhost') && !href.includes('staging.buy.mexipass.com') && !href.includes('staging.buy.avocadoinsurance.com') ) {
      window.dataLayer.push(o)
    }
  },

  async setGoogleTagManagerId(tagId) {
    return new Promise((resolve) => {

      if ( !window.__gtmLoaded ) {
        
        let normalized = (tagId || '').toString().trim().toUpperCase()
        if ( /^GTM-[A-Z0-9]+$/.test(normalized) ) {

          this.ga({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

          if ( typeof window._googWcmGet != 'function' ) {
            window._googWcmGet = function(phoneNumber, callback) {
              if ( typeof callback == 'function' ) {
                callback(phoneNumber || '')
              }
              return phoneNumber || ''
            }
          }

          let script = document.createElement('script')
          script.async = true
          script.dataset.runtimeGtm = 'true'
          script.dataset.runtimeGtmId = normalized
          script.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(normalized)
          script.onload = function() {
            window.__gtmLoaded = true
            resolve(true)
          }
          script.onerror = function() {
            resolve(false)
          }
          document.head.appendChild(script)
        } else {
          resolve(false)
        }
      } else {
        resolve(true)
      }

    })
  },

  gaRateEvent(screen, startDate, daysOfCoverage, vehicleValue, coverageLevelValue, xdaysCost, annualCost) {
    this.ga({
      'screen': screen,
      'policyStartDate': startDate,
      'daysOfCoverage': daysOfCoverage,
      'vehicleValue': vehicleValue,
      'coverageLevel': coverageLevelValue,
      'priceQuotedDays': xdaysCost,
      'priceQuotedAnnual': annualCost,
    })
    this.ga({
      'screen': screen,
      'event': 'priceQuoted'
    })
  },

  setupTooltips() {
    /*global bootstrap*/
    /*eslint no-undef: "error"*/
    if (this.$tooltips != null) {
      this.$tooltips.map(el => el.dispose())
    }
    this.$tooltips = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(el => new bootstrap.Tooltip(el))
  }
}
